import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, unref as _unref } from "vue"

const _hoisted_1 = ["data-analytics-element-detail"]
const _hoisted_2 = {
  key: 0,
  class: "lz-py-4"
}
const _hoisted_3 = { class: "lz-h-full lz-relative" }
const _hoisted_4 = ["data-analytics-element-detail"]

import { onBeforeUnmount, onMounted, Ref, computed, inject, ref, withDefaults, watch } from 'vue'
import CollapseTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'
import events from '@/events'
import LzIcon from '@/components/base/LzIcon.vue'

const ANIM_DURATION = 1500


export default /*#__PURE__*/_defineComponent({
  __name: 'LzAccordion',
  props: {
    id: {},
    title: { default: '' },
    group: { default: '' },
    open: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: true },
    background: { default: 'lz-bg-service-1' },
    contrast: { type: Boolean, default: false },
    customColor: {}
  },
  emits: ["toggle"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





/* refs */
const el: Ref<HTMLElement | null> = ref(null)
const visible = ref(props.open)
const contentVisible = ref(false)
/* injects */
const activeId: Ref<string> = inject('activeId')
const numTabs: number = inject('numTabs')
const allClosed: Ref<boolean> = inject('allClosed')
const containerWidth: Ref<number> = inject('containerWidth')
/* computed */
const isLastChild = computed(() => el.value ? !el.value.nextElementSibling : true)
const tabWidth = computed(() => allClosed.value ? { width: `${containerWidth.value / numTabs}px` } : {})
const width = computed(() => visible.value ? `${containerWidth.value - (112 * numTabs)}px` : '0px')
const contentWidth = computed(() => `${containerWidth.value - (112 * numTabs)}px`)
const backgroundColor = computed(() => props.customColor ? props.customColor : '')

watch(allClosed, () => {
    if (allClosed.value) {
        visible.value = false
    }
})

__expose({ visible })

events.$on('accordion-open', onAccordionOpened)
/* lifecycle hooks */
// eslint-disable-next-line no-undef
onMounted(() => {
    window.addEventListener('resize', checkOpenState)
})

// eslint-disable-next-line no-undef
onBeforeUnmount(() => {
    window.removeEventListener('resize', checkOpenState)
})


// in mobile multiple tabs can be opened, so when we switch back to desktop (or whenever
// the screen size changes, close all but one tab
function checkOpenState() {
    visible.value = visible.value && props.id === activeId.value
}

function onAccordionOpened(group: string) {
    if (!props.group || props.group === '') {
        return
    }
    if (props.group === group) {
        visible.value = false
        contentVisible.value = false
    }
}

function toggle(closeOthers = true) {
    if (!visible.value && closeOthers) {
        events.$emit('accordion-open', props.group)
    } else {
        contentVisible.value = false
    }
    visible.value = !visible.value
    setTimeout(() => {
        contentVisible.value = visible.value
    }, ANIM_DURATION)
    emit('toggle', { id: props.id, open: visible.value, closeOthers })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    ref_key: "el",
    ref: el,
    class: _normalizeClass({ 'lz-text-white': _ctx.contrast })
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["lz-relative lz-py-8 -lz-mx-4 lz-px-4 lz-text-sm lg:lz-hidden", _ctx.background]),
      style: _normalizeStyle({ backgroundColor: backgroundColor.value }),
      "data-analytics-event-name": "subject_click",
      "data-analytics-event-category": "Engagement",
      "data-analytics-element-type": "Service-Phase",
      "data-analytics-element-detail": _ctx.title
    }, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (toggle(false))),
        class: "lz-flex lz-justify-between lz-text-lg lz-items-center lz-font-bold"
      }, [
        _createElementVNode("span", {
          class: _normalizeClass({ 'lz-opacity-60': !visible.value })
        }, _toDisplayString(_ctx.title), 3),
        _createVNode(LzIcon, {
          name: visible.value ? 'minus' : 'plus',
          class: "lz-w-4 lz-h-4"
        }, null, 8, ["name"])
      ]),
      _createVNode(CollapseTransition, null, {
        default: _withCtx(() => [
          (visible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _renderSlot(_ctx.$slots, "default")
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }),
      (!isLastChild.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["lz-w-6 lz-h-6 lz-rotate-45 lz-translate-y-1/2 -lz-translate-x-1/2 lz-absolute lz-z-10 lz-left-1/2 lz-bottom-0 lz-duration-500 lz-transition-all", [_ctx.background, { '-lz-translate-y-full lz-opacity-0': visible.value }]]),
            style: _normalizeStyle({ backgroundColor: backgroundColor.value })
          }, null, 6))
        : _createCommentVNode("", true)
    ], 14, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(["lz-hidden lg:lz-block lg:lz-h-service lz-py-4 lz-float-left lz-overflow-hidden", _ctx.background]),
      style: _normalizeStyle({ transition: 'all 0ms ease', width: width.value, backgroundColor: backgroundColor.value, transitionDelay: _unref(allClosed) ? '0' : '100ms', transitionDuration: _unref(allClosed) ? '300ms' : '600ms' })
    }, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default", { width: contentWidth.value })
      ])
    ], 6),
    _createElementVNode("div", {
      class: _normalizeClass([[_ctx.background, { 'lz-w-28': !_unref(allClosed) }], "lz-group lz-hidden lz-relative lg:lz-block lz-cursor-pointer lg:lz-h-service lz-float-left lz-text-center lz-transition-all lz-duration-700"]),
      style: _normalizeStyle({ backgroundColor: backgroundColor.value, ...tabWidth.value }),
      onClick: toggle,
      "data-analytics-event-name": "subject_click",
      "data-analytics-event-category": "Engagement",
      "data-analytics-element-type": "Service-Phase",
      "data-analytics-element-detail": _ctx.title
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["lz-absolute lz-top-0 lz-right-0 lz-w-1/2 lz-z-20 lz-h-full lz-border-solid lz-border-0 lz-border-r-4 lz-origin-left lz-transition-transform lz-duration-400 lz-ease-in-out", [_ctx.background, visible.value ? 'lz-border-primary' : 'lz-border-transparent group-hover:lz-translate-x-4']]),
        style: _normalizeStyle({ backgroundColor: backgroundColor.value })
      }, [
        (!isLastChild.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["lz-w-6 lz-h-6 lz-rotate-45 lz-absolute lz-z-30 -lz-right-4 lz-top-8 lz-duration-500 lz-transition-transform", [_ctx.background, { '-lz-translate-x-full': visible.value }]]),
              style: _normalizeStyle({ backgroundColor: backgroundColor.value })
            }, null, 6))
          : _createCommentVNode("", true)
      ], 6),
      _createElementVNode("div", {
        class: _normalizeClass([[visible.value ? 'lz-text-primary' : `${_ctx.contrast ? 'lz-text-white' : 'lz-text-gray-600'}`, { 'lz-opacity-60': !visible.value && !_unref(allClosed) }], "lz-absolute lz-right-8 lz-pr-16 lz-z-20 lz-whitespace-nowrap lz-font-bold lz-text-2xl lz-origin-right -lz-rotate-90 lz-transition-all group-hover:lz-opacity-100 group-hover:lz-text-primary"])
      }, _toDisplayString(_ctx.title), 3)
    ], 14, _hoisted_4)
  ], 2))
}
}

})